var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrefourAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4484_6081)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip1_4484_6081)",
    filter: "url(#filter0_f_4484_6081)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3176 9.88483C20.4596 9.74418 20.5995 9.6875 20.7182 9.6875C20.9311 9.6875 21.0795 9.87434 21.0742 10.1021C21.0668 10.2386 21.0074 10.3866 20.8729 10.5188C15.6001 17.014 11.7632 24.6103 11.7632 35.1434C11.7632 45.6715 15.6001 53.1175 20.8729 59.6119C21.0074 59.7428 21.0668 59.8994 21.0742 60.0306C21.0795 60.2582 20.9311 60.444 20.7182 60.444C20.5995 60.444 20.4596 60.3895 20.3176 60.2458L-2.16259 38.709C-3.28369 37.7602 -4 36.6497 -4 35.0678C-4 33.4808 -3.28369 32.3714 -2.16259 31.4277L20.3176 9.88483Z",
    fill: "#D30D1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3611 8C28.5619 8 25.1245 20.3564 25.1245 35.0797C25.1245 49.8095 28.5619 62 37.3611 62C42.6435 62 47.1448 58.935 47.1606 56.4169C47.1606 55.867 46.9477 55.341 46.4814 54.8804C43.9796 52.4849 43.0027 50.0898 42.9898 47.9767C42.9772 43.9419 46.5112 40.9389 49.7641 40.9389C54.2432 40.9389 56.8828 44.4246 56.8828 48.9371C56.8828 53.2134 55.0411 56.7801 53.0427 59.6321C52.9632 59.7474 52.9293 59.8764 52.9293 59.9909C52.9293 60.2123 53.0616 60.3973 53.262 60.3973C53.385 60.3973 53.5257 60.3333 53.6785 60.1821L76.1618 38.6455C77.2819 37.6965 78.0003 36.5849 78.0003 35.0043C78.0003 33.4171 77.2819 32.3077 76.1618 31.364L53.6785 9.82113C53.5257 9.67313 53.385 9.60595 53.262 9.60595C53.0575 9.60595 52.9293 9.79279 52.9293 10.0164C52.9293 10.1318 52.9632 10.2599 53.0427 10.3795C55.0411 13.2283 56.8828 16.795 56.8828 21.066C56.8828 25.5774 54.2432 29.0695 49.7641 29.0695C46.5112 29.0695 42.9772 26.0623 42.9898 22.0274C43.0027 19.9187 43.9796 17.5213 46.4814 15.1281C46.9477 14.6642 47.1606 14.1394 47.1606 13.5883C47.1448 11.0681 42.6435 8 37.3611 8Z",
    fill: "#254F9A"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4484_6081)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4898 25.7446C30.5452 25.689 30.5998 25.6666 30.6461 25.6666C30.7292 25.6666 30.7871 25.7404 30.785 25.8304C30.7822 25.8843 30.759 25.9428 30.7065 25.995C28.6488 28.561 27.1515 31.562 27.1515 35.7233C27.1515 39.8825 28.6488 42.8242 30.7065 45.3898C30.759 45.4416 30.7822 45.5034 30.785 45.5553C30.7871 45.6452 30.7292 45.7186 30.6461 45.7186C30.5998 45.7186 30.5452 45.697 30.4898 45.6403L21.717 37.1319C21.2795 36.7571 21 36.3184 21 35.6934C21 35.0665 21.2795 34.6282 21.717 34.2554L30.4898 25.7446Z",
    fill: "#D30D1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1409 25C33.7071 25 32.3657 29.8815 32.3657 35.6981C32.3657 41.5173 33.7071 46.3333 37.1409 46.3333C39.2024 46.3333 40.9589 45.1225 40.9651 44.1277C40.9651 43.9104 40.882 43.7026 40.7001 43.5206C39.7237 42.5743 39.3425 41.6281 39.3375 40.7933C39.3326 39.1993 40.7117 38.0129 41.9811 38.0129C43.7291 38.0129 44.7592 39.39 44.7592 41.1727C44.7592 42.8621 44.0404 44.2711 43.2606 45.3979C43.2296 45.4434 43.2163 45.4944 43.2163 45.5396C43.2163 45.6271 43.268 45.7002 43.3461 45.7002C43.3941 45.7002 43.4491 45.6749 43.5087 45.6151L52.2827 37.1069C52.7198 36.7319 53.0001 36.2928 53.0001 35.6684C53.0001 35.0413 52.7198 34.603 52.2827 34.2302L43.5087 25.7195C43.4491 25.661 43.3941 25.6345 43.3461 25.6345C43.2664 25.6345 43.2163 25.7083 43.2163 25.7966C43.2163 25.8422 43.2296 25.8928 43.2606 25.9401C44.0404 27.0655 44.7592 28.4746 44.7592 30.1619C44.7592 31.9441 43.7291 33.3238 41.9811 33.3238C40.7117 33.3238 39.3326 32.1357 39.3375 30.5417C39.3425 29.7086 39.7237 28.7615 40.7001 27.8161C40.882 27.6328 40.9651 27.4254 40.9651 27.2077C40.9589 26.2121 39.2024 25 37.1409 25Z",
    fill: "#254F9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4484_6081",
    x: -54,
    y: -42,
    width: 182,
    height: 154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_4484_6081"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4484_6081"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4484_6081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 54,
    fill: "white",
    transform: "translate(-4 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4484_6081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 21.3333,
    fill: "white",
    transform: "translate(21 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrefourAppIcon);
export default __webpack_public_path__ + "static/media/carrefour-app-icon.868b18c76a0409c3fa1b977cbb368421.svg";
export { ForwardRef as ReactComponent };